import autobind from 'autobind-decorator';
import { computed, extendObservable } from 'mobx';
import { Url } from '../../../../../../common/constants/environment';
import moment from 'moment';

@autobind
class MatchCheerCommentModel {
  constructor(data) {
    extendObservable(this, data);
  }

  @computed
  get user() {
    const {
      profile_image_path,
      mb_nick,
      level,
      user_id,
      home_away,
      is_admin
    } = this;
    // content: "안녕하세여"
    // create_at: "2020-12-15 19:00:08"
    // device: "WEB"
    // game_id: "10625112"
    // gender: "m"
    // home_away: "HOME"
    // id: "6840070"
    // image_path: null
    // ip: "172.16.20.93"
    // is_admin: false
    // is_deleted: "0"
    // is_filter_word: false
    // is_jail: false
    // level: "21"
    // mb_nick: "따상"
    // profile_image_path: (...)
    // sports_id: "1"
    // user_id: "54q0fxan161d7219222fc6e352eb6c6faecc2ac1"

    let result = {
      home_away: home_away,
      level: level,
      nick: mb_nick,
      is_admin: is_admin,
      user_id: user_id,
      profile_img: '/images/thumb_user_def.png'
    };

    if (!!profile_image_path) {
      result.profile_img = `${Url.thumb}normal/crop/112x112${profile_image_path}`;
    }

    return result;
  }

  @computed
  get createAtMoment() {
    return moment(this.create_at);
  }
}

export default MatchCheerCommentModel;
